import React from 'react';
import styled from 'styled-components';
import { getColor } from '../../../styling/mixins/colors';
import RadioButton from '../../Inputs/Radiobutton';
import { fontFamilyBold, text } from '../../../styling/mixins/typography';

interface CheckoutRadioProps {
  className?: string;
  title?: string;
  description?: string;
  cost?: string;
  logo?: JSX.Element | string;
  stateKey?: string;
  id?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  checked?: boolean;
  extraInfo?: string;
}

const StyledCheckoutRadioWrapper = styled.label`
  display: flex;
  flex: 1;
  cursor: pointer;
  padding: 1.2rem 1.6rem;
  border: 1px solid ${getColor('grey', 200)};
  border-radius: 4px;
  margin-bottom: 1.6rem;
  align-items: center;
  &:last-child {
    margin-bottom: unset;
  }

  .text-wrapper {
    display: flex;
    flex: 1;
    flex-direction: column;
    margin-left: 1.6rem;
    gap: 0.8rem;
  }

  .title {
    ${text('xlarge')}
    ${fontFamilyBold}
    line-height: 2.7rem;
  }
  .description {
    line-height: 2.4rem;
  }
  .extra-info {
    color: ${getColor('grey', 400)};
  }
  .end {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .logo {
    display: flex;
    align-items: center;
    margin-left: 1.6rem;
  }
  .button-wrapper {
    //radiobutton
  }
`;

const CheckoutRadio = ({
  className,
  title,
  description,
  cost,
  logo,
  stateKey,
  id,
  onChange,
  checked = false,
  extraInfo = ""
}: CheckoutRadioProps) => {
  return (
    <StyledCheckoutRadioWrapper
      htmlFor={`${stateKey}-${id}`}
      className={`${className ?? ''}`}
    >
      <RadioButton
        checked={checked}
        name={stateKey}
        type="radio"
        id={`${stateKey}-${id}`}
        onChange={onChange}
      />
      <div className="text-wrapper">
        <span className="title">{title}</span>
        {description && <span className="description">{description}</span>}
        {extraInfo && extraInfo != "" && <span className="extra-info">{extraInfo}</span>}
      </div>
      <div className="end">
        <span>{cost}</span>
        {logo && <span className="logo">{logo}</span>}
      </div>
    </StyledCheckoutRadioWrapper>
  );
};

export default CheckoutRadio;
